<template lang="pug">
div.container
  div.message-area
    p.message(v-if="!error")
      | バーコード写真を撮影するか、または、撮影済みのバーコード写真から読み取ります。
      | バーコードが写真の中央に、はっきり写るよう、明るいところで撮影ください。
    p.message(v-else)
      | バーコードが読み取れませんでした。<br>バーコードが写真の中央に、はっきり写るよう
      | 明るいところで撮影をお試しください。

    div.barcode-btn-area
      input(type="file" id="camera" @change="decodePicture")
      label.btn-camera(for="camera")
        font-awesome-icon.fa-cam-icon(icon="camera")
        span &ensp;写真を選択する

  div.change-stream-btn-area(v-if="userDevice==='Android'")
    button.btn-change-stream(@click="useLiveStream")
      font-awesome-icon.fa-cam-icon(icon="video")
      span &ensp;ライブカメラに切り替え

  div.favorite-btn-area
    button.btn-favorite(v-if="!error" @click="$router.push('/favorite')")
      font-awesome-icon(:style="heartStyle" icon="heart")
      span &ensp;チェックした商品をみる
</template>

<script>
import quagga from "quagga";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faVideo, faCamera, faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "ImageStream",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  props: {
    userDevice: {
      type: String,
      requires: true,
      default: ""
    }
  },
  data() {
    library.add(faVideo);
    library.add(faCamera);
    library.add(faHeart);
    return {
      error: false,
      heartStyle: {
        color: "#53433e",
        stroke: "#ffffff",
        strokeWidth: "60px"
      }
    };
  },
  methods: {
    decodePicture(e) {
      const file = e.target.files[0];
      const state = {
        inputStream: {
          type: "ImageStream",
          constraints: {
            width: 1920,
            height: 1080,
            facingMode: "environment",
            aspectRatio: { min: 1, max: 2 }
          }
        },
        locator: {
          patchSize: "medium",
          halfSample: true
        },
        numOfWorkers: 4,
        frequency: 8,
        decoder: {
          readers: [
            {
              format: "ean_reader",
              config: {}
            }
          ]
        },
        locate: true,
        src: URL.createObjectURL(file)
      };
      quagga.decodeSingle(state, result => {
        if (result && result.codeResult) {
          this.$router.push({
            name: "result",
            params: { jan: result.codeResult.code, sendEvent: true }
          });
        } else {
          this.error = true;
        }
      });
    },
    useLiveStream() {
      this.$emit("changeLiveStream");
    }
  }
};
</script>

<style lang="sass" scoped>
/* page layouts */
.fa-cam-icon
  font-size: 1.6em

.barcode-btn-area
  align-items: center
  display: flex
  justify-content: center

.favorite-btn-area
  align-self: center
  height: 4.2vh


/* objects */
.message-area
  padding: 6vh 10vw 0px
  width: 80%
  height: 60vh
  max-height: 55vh

.message
  align-self: center
  margin: 16vh 0 0
  padding: 0 5vw

#camera
  display: none

.btn-camera
  align-items: center
  background: #53433e
  border-radius: 3vh
  color: white
  display: flex
  height: 6vh
  justify-content: center
  margin: 3.6vh 0 5vh
  width: 55vw

.change-stream-btn-area
  margin-top: 2vh
  .btn-change-stream
    background: none
    color: #53433e
    align-items: center
    display: flex
    justify-content: center
    margin: auto
    border-radius: 10px
    width: 76vw
    height: 8vmax
    font-size: 2.5vmax

.favorite-btn-area
  height: 6vmax
  margin-top: 5%
  .btn-favorite
    align-items: center
    display: flex
    justify-content: center
    margin: auto
    border-radius: 2em
    width: 60vw
    height: 6vmax
    font-size: 2vmax
</style>
